<template>
  <div class="cb-input-group input-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CbInputGroup'
}
</script>
